import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  containerInfo: {
    marginTop: '16px',
  },
}));
